<template>
	<div class="flex-1 flex flex-col">
		<div class="flex-1 m-2">
			<div class="flex justify-between items-end p-2 my-5">
				<h1 class="text-gray-700 text-xl sm:text-3xl leading-none">
					<template v-if="job.name">{{ job.name }}</template> Warehouse
				</h1>

				</div>
				<div class="grid grid-cols-12 gap-2 mb-4 text-sm bg-gray-200 p-2">
					<div class="col-span-6">product</div>
					<div class="col-span-2">total</div>
					<div class="col-span-2">rem</div>
					<div class="col-span-2">taken</div>
				</div>
				<div class="grid grid-cols-12">
					<template v-for="(phase, pindex) in phases">
						<div class="col-span-12 py-1 font-bold">Phase </div>
						<template v-for="(product, index) in phase.ret_gen">
							<div class="col-span-6 py-2 px-3">
								{{ product.name }}
							</div>
							<div class="col-span-2">
								{{ product.total_delivered }}
							</div>
							<div class="col-span-2">
								{{ product.total_installed }}
							</div>
							<div class="col-span-2 py-2 px-3 flex justify-between items-center">
								<input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" :id="`${pindex}-taken`" type="text" v-model="product.taken" placeholder="Taken">
							</div>
						</template>
					</template>
				</div>
			</div>
		</div>
	</template>

	<script>
		export default {

			name: 'SiteWarehouse',

			data () {
				return {
					job: {},
					products: {},
					phases: {},
				}
			},
			computed: {
				jobId: function () {
					return this.$route.params.id;
				}
			},
			created: function(){
				this.$http.get(`/jobs/${this.jobId}/sitewarehouse`)
				.then(response => {
					console.log(response.data);
					this.job = response.data.jobdetails;
					this.products = response.data.job_products;
					this.phases = response.data.phases;
				})
				.catch(error => {
					let err = {
						title: 'Server responded with a ' + error.response.status,
						message: error.response.data.message,
						type: 'error'
					}
					this.$store.commit('setStatus', err)
					this.products = {};
				})
				.finally(() => {
				});
			}
		}
	</script>

	<style lang="css" scoped>
</style>